// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  test: 'DEVELOPMENT',
  key: '',
  api: 'https://spin-api-dev.mobilesoftapps.it',
  cms: 'https://spin-cms-dev.mobilesoftapps.it',
  infocertBase: 'https://topcl.infocert.it/rest10/',
  signBase: 'https://sign-dev.mobilesoftapps.it',
  keycloak: {
    issuer: 'https://spin-secure-dev.mobilesoftapps.it/',
    realm: 'spin',
    clientId: 'spin-realm',
    issuer_locale: 'https://spin-secure-dev.mobilesoftapps.it/',
    realm_locale: 'spin',
    clientId_locale: 'spin-realm',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
